import React from 'react';
import { Popover } from 'antd';
import styles from './index.module.scss';
import classNames from 'classnames';

interface IProps {
  readonly placement?:
    | 'top'
    | 'left'
    | 'right'
    | 'bottom'
    | 'topLeft'
    | 'topRight'
    | 'bottomLeft'
    | 'bottomRight'
    | 'leftTop'
    | 'leftBottom'
    | 'rightTop'
    | 'rightBottom';
  readonly visible?: boolean;
  readonly trigger?: 'hover' | 'focus' | 'click' | 'contextMenu';
  readonly content: React.ReactNode;
  readonly children: React.ReactNode;
  readonly overlayClassName?: string;
  readonly maxWidth?: number;
}

export const CustomPopover = ({
  placement = 'top',
  trigger = 'hover',
  visible,
  content,
  children,
  overlayClassName,
  maxWidth,
}: IProps): JSX.Element => (
  <Popover
    overlayStyle={{ maxWidth: maxWidth || '' }}
    overlayClassName={classNames(styles.settingTooltip, overlayClassName)}
    placement={placement}
    visible={visible}
    content={content}
    trigger={trigger}
  >
    {children}
  </Popover>
);
